import { ReactNode } from 'react';

import { Flex, Stack } from '@iwoca/orion';

export const FundingRequirementsShell = ({
    sidePanel,
    progressIndicator,
    mainContent
}: {
    sidePanel: ReactNode;
    progressIndicator: ReactNode;
    mainContent: ReactNode;
}) => (
    <Flex background="canvas" gap="none">
        {/* ORION-113-GAP token: no surface for the denim panel */}
        <Flex.Item
            basis="panel"
            shrink={false}
            hideBelow="desktop"
            className="bg-primary-10 text-structure-100"
        >
            {/* ORION-113-GAP component: no Sticky, so the header offset
                and full height are set by hand */}
            {/* ORION-113-GAP token: 60px padding is above the largest
                padding token */}
            <Flex
                direction="column"
                gap="section"
                className="sticky top-header-offset min-h-[calc(100dvh-var(--header-offset))] p-4xl"
            >
                {sidePanel}
            </Flex>
        </Flex.Item>
        <Flex.Item grow>
            <Stack padding="layout" gap="section">
                {progressIndicator}
                {mainContent}
            </Stack>
        </Flex.Item>
    </Flex>
);
